import { connect } from 'react-redux';
import NavigationBar from './NavigationBar';

const mapStateToProps = (state) => {
  const pathname = state.routing.locationBeforeTransitions.pathname.split('/');
  return {
    deep: !!pathname[3],
  };
};

const mapDispatchToProps = (dispatch) => ({});

const NavigationBarContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(NavigationBar);

export default NavigationBarContainer;
